



















export default {
  props: {
    state: { type: String, required: true },
    onRemove: { type: Function, default: () => {} }
  },
  computed: {
    removeButtonShown() {
      const statessAllowedToRemove = ['UPLOADING', 'UPLOADED', 'ERROR', 'REJECTED']
      return statessAllowedToRemove.includes(this.state)
    },
    statusProps() {
      if (this.state === 'SUBMITTED')
        return {
          state: 'disabled',
          text: this.$t('myTransports.transportDetails.pod.statuses.inValidation')
        }
      if (this.state === 'APPROVED')
        return {
          state: 'success',
          text: this.$t('myTransports.transportDetails.pod.statuses.accepted')
        }
      if (this.state === 'REJECTED')
        return {
          state: 'error',
          text: this.$t('myTransports.transportDetails.pod.statuses.rejected')
        }
      return { state: 'error', text: 'File without status' }
    },
    isValidState() {
      return (
        this.state === 'SUBMITTED' ||
        this.state === 'APPROVED' ||
        this.state === 'REJECTED'
      )
    }
  }
}
